"use client";
import Image from "next/image";
import * as images from "@/components/images/Images";
import { memo } from "react";

const FooterCTAImage = ({ isPricingPage }: { isPricingPage: boolean }) => {
  return isPricingPage ? (
    <>
      <Image
        src={images.pricing_Footer}
        alt="Languex logo"
        width={0}
        height={0}
        className="h-[425px] w-auto hidden lg:block"
        loading="lazy"
      />
      <div className="flex max-h-[200px] -mx-4 -mb-[25px] lg:max-h-none lg:m-0">
        <Image
          src={images.footerBgImageMobile}
          alt="Languex logo"
          width={718}
          height={324}
          className="lg:hidden w-auto max-h-full"
          loading="lazy"
        />
      </div>
    </>
  ) : (
    <div className="flex max-h-[200px] -mx-4 -mb-[25px] lg:max-h-none lg:m-0">
      <Image
        src={images.footerBgImageMobile}
        alt="Languex logo"
        width={718}
        height={324}
        className="lg:hidden w-auto max-h-full"
        loading="lazy"
      />
      <Image
        src={images.footerBgImage}
        alt="Languex logo"
        width={0}
        height={0}
        className="hidden lg:block"
        loading="lazy"
      />
    </div>
  );
};

export default memo(FooterCTAImage);
